import * as React from "react";
import Switch from "@mui/material/Switch";

const label = { inputProps: { "aria-label": "Switch demo" } };

export default function Toggle(props) {
  const {
    name,
    id,
    placeholder,
    options,
    className,
    onChange,
    required,
    errorMessage,
    value,
  } = props;
  return (
    <Switch
      name={name}
      required={required}
      onChange={onChange}
      className={className}
      label={placeholder}
      // value={value}
      // value={options.find((item) => item.value === value)}
      id={id}
      checked={value}
    />
  );
}
